<div fxLayout="column" class="content-style-class">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div fxLayout="column">
      <h2 class="title-style">{{ projectTitle }}</h2>
    </div>
    <div
      *appCheckPermission="{
        context: PermissionContext.Project,
        action: Action.CREATE,
      }"
    >
      <div fxLayout="column" class="add-button-style">
        <abc-speed-dial-action icon="add" (onClick)="openCreateProject()">
        </abc-speed-dial-action>
      </div>
    </div>
  </div>
  <div class="content-block project-container">
    <div class="dx-card responsive-paddings card-radius">
      <abc-grid
        #projectGrid
        class="grid-group-by-Style chech-box-Column custome-export-style grid-adaptive-mode"
        [height]="'100%'"
        [noDataText]="noDataText"
        [hoverStateEnabled]="false"
        [showRowLines]="false"
        [setupDefaultLayoutOnInitialization]="true"
        [columns]="columnsHeader"
        [dataSource]="projectList"
        (onCellPrepared)="onCellPrepared($event)"
        (onCellClick)="onCellClick($event)"
        (onExporting)="dataService.onExporting($event, exportFileName)"
        [columnHidingEnabled]="true"
        [wordWrapEnabled]="true"
        [columnAutoWidth]="false"
      >
        <dxo-export
          [enabled]="true"
          [allowExportSelectedData]="false"
          [formats]="['pdf', 'xlsx']"
        ></dxo-export>
        <dxo-column-chooser [enabled]="false"> </dxo-column-chooser>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-editing [allowAdding]="false"> </dxo-editing>
        <dxo-state-storing [enabled]="false"></dxo-state-storing>

        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-filter-panel [visible]="true" S> </dxo-filter-panel>
        <dxo-search-panel [visible]="true"> </dxo-search-panel>
      </abc-grid>
    </div>
  </div>
</div>
<abc-popup
  #deleteProjectpopup
  [width]="'90%'"
  [maxWidth]="700"
  fxLayout="column"
  fxLayoutAlign="center center"
  [height]="'auto'"
  [title]="dataService.res('Ubt-Company-Title-Confirm-Delete')"
  [showCloseButton]="true"
>
  <div
    class="dx-card popup-card-paddings card-radius"
    fxLayout="column"
    fxLayoutAlign="center center"
    fxLayoutGap="20px"
  >
    <div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="20px">
      {{ dataService.res("Ubt-Project-Remove-Message") }}
    </div>
    <dxi-item
      itemType="group"
      fxLayout="row"
      fxLayoutAlign="end end"
      fxLayoutGap="20px"
    >
      <abc-button
        class="submit-button"
        [text]="dataService.res('Ubt-Company-Icon-Delete')"
        (onClick)="confirmRemoveProject($event)"
      >
      </abc-button>
      <abc-button
        class="cancel-button"
        [text]="dataService.res('Ubt-Company-Button-Cancel')"
        (onClick)="abort()"
      >
      </abc-button>
    </dxi-item>
  </div>
</abc-popup>
<abc-popup
  #createProjectpopup
  [showTitle]="true"
  [title]="title"
  [position]="'center'"
  [deferRendering]="'false'"
  [height]="'auto'"
  [width]="'90%'"
  [maxWidth]="700"
  [showCloseButton]="true"
  (onHiding)="clearPopup()"
>
  <div
    class="dx-card popup-card-paddings card-radius"
    fxLayout="column"
    fxFlexFill
    fxLayoutGap="10px"
    [class.isLoading]="isLoading()"
  >
    <form action="post" (submit)="createProject($event)">
      <abc-form #form id="form" [(formData)]="project" [colCount]="1">
        <dxi-item [isRequired]="true">
          <abc-text-box
            [stylingMode]="'outlined'"
            [width]="'100%'"
            [(value)]="project.Designation"
            [label]="this.dataService.res('Ubt-MeasureTask-Label')"
            [labelMode]="'floating'"
          >
          </abc-text-box>
          <dxi-validation-rule
            type="required"
            message="{{
              dataService.res('Ubt-Validator-Required-Designation')
            }}"
          ></dxi-validation-rule>
        </dxi-item>
        <dxi-item
          itemType="group"
          [colCount]="3"
          [cssClass]="'form-fields-row'"
        >
          <dxi-item>
            <abc-date-box
              class="date-box-style"
              fxFlex="100"
              [label]="dataService.res('Ubt-MeasureTask-Start-Date')"
              [(value)]="project.StartDate"
              type="date"
              [labelMode]="'floating'"
            >
            </abc-date-box>
          </dxi-item>
          <dxi-item>
            <abc-date-box
              class="date-box-style"
              fxFlex="100"
              [label]="dataService.res('Ubt-MeasureTask-End-Date')"
              [(value)]="project.EndDate"
              type="date"
              [labelMode]="'floating'"
              [min]="project.StartDate"
            >
            </abc-date-box>
          </dxi-item>
          <dxi-item>
            <abc-number-box
              #numberBox
              [stylingMode]="'outlined'"
              class="date-box-style"
              fxFlex="100"
              [label]="
                dataService.res('Ubt-MeasureTask-NotificationReminderDaysValue')
              "
              [(value)]="project.NotificationReminderDaysValue"
              [showSpinButtons]="true"
              [labelMode]="'floating'"
            >
            </abc-number-box>
          </dxi-item>
        </dxi-item>
        <dxi-item fxFlex="100">
          <abc-text-box
            [stylingMode]="'outlined'"
            [width]="'100%'"
            [(value)]="project.State"
            [label]="dataService.res('Ubt-MeasureTask-State')"
            [labelMode]="'floating'"
          >
          </abc-text-box>
        </dxi-item>
        <dxi-item>
          <abc-text-area
            [height]="'200px'"
            [stylingMode]="'outlined'"
            [width]="'100%'"
            [(value)]="project.Description"
            [label]="dataService.res('Ubt-MeasureDetail-Description')"
            [labelMode]="'floating'"
          >
          </abc-text-area>
        </dxi-item>
        <dxi-item>
          <abc-tag-box
            #MembersTagBox
            class="member-tag-box"
            height="100px"
            [dataSource]="members"
            (onSelectionChanged)="addRemoveMember($event)"
            [(value)]="projectMembers"
            displayExpr="Name"
            valueExpr="Id"
            [label]="dataService.res('Ubt-CreateMeasure-Members')"
            [labelMode]="'floating'"
            [showSelectionControls]="true"
            [searchEnabled]="true"
          >
          </abc-tag-box>
        </dxi-item>
        <dxi-item class="info-message">
          <span class="info-message-text">{{isUpdating ? updateProjectInfoMessage : createProjectInfoMessage}}</span>
          <span
            class="dx-icon dx-icon-info info-icon"
          ></span>
        </dxi-item>
        <abc-button icon="info"></abc-button>
        <dxi-item itemType="group" [cssClass]="'form-buttons-container'">
          @if (!isUpdating) {
            <dxi-item
              itemType="button"
              [cssClass]="'submit-button'"
              [buttonOptions]="createButtonOptions"
            >
            </dxi-item>
          }
          @if (isUpdating) {
            <dxi-item
              itemType="button"
              [cssClass]="'submit-button'"
              [buttonOptions]="updateButtonOptions"
            >
            </dxi-item>
          }
          <dxi-item
            itemType="button"
            [cssClass]="'cancel-button'"
            [buttonOptions]="cancelButtonOptions"
          >
          </dxi-item>
        </dxi-item>
      </abc-form>
    </form>
    @if (isLoading()) {
      <ubt-loader></ubt-loader>
    }
  </div>
</abc-popup>
<abc-context-menu
  #contextMenu
  id="contextMenu"
  class="abc-context-menu"
  showEvent="abcclick"
  [items]="contextMenuItems"
  [position]="{ my: 'top right', at: 'bottom right' }"
>
</abc-context-menu>
